import { create } from './create';
import { Command } from 'commander';
import { logError } from './logger';

const program = new Command();
let command: string | undefined = undefined;

program
  .version('1.0.0')
  .arguments('<cmd>')
  .action(function(cmd: string) {
    command = cmd;
  });

program.parse(process.argv);

if (typeof command === 'undefined') {
  logError('no command given!');
  process.exit(1);
}

if (command === 'create') {
  create()
    .then()
    .catch();
}
